import { useAppSelector } from 'state/hooks'

import { AppState } from '../types'

export function useFarmState() {
  return useAppSelector((state: AppState) => state.farm)
}

export function useFarmPools() {
  return useAppSelector((state: AppState) => state.farm.pool)
}

export function useFarmPoolById(id: string) {
  const pools = useFarmPools()
  return {
    status: pools.status,
    data: pools.data[id],
  }
}

export function useFarmIncentives() {
  return useAppSelector((state: AppState) => state.farm.incentive)
}
